let isFocused = false;

document
  .getElementById("main-menu-toggle")
  .addEventListener("click", function (event) {
    if (!isFocused) {
      mobileMenuToggleEfdc();
    }
  });

document.addEventListener("keydown", function (event) {
  if (event.key === "Escape") {
    mobileMenuToggleEfdc(true);
  }
});
document
  .getElementById("menu-main-nav")
  .addEventListener("focusout", function (event) {
    if (
      !event.currentTarget.contains(event.relatedTarget) &&
      event.relatedTarget
    ) {
      isFocused = true;
      mobileMenuToggleEfdc(true);
      setTimeout(() => {
        isFocused = false;
      }, 200);
    }
  });

document.addEventListener("click", function (event) {
  isFocused = false;
  const nav = document.getElementById("menu-main-nav");
  const button = document.getElementById("main-menu-toggle");
  if (!nav.contains(event.target) && !button.contains(event.target)) {
    mobileMenuToggleEfdc(true);
  }
});

document.querySelectorAll(".menu-main__button").forEach((button) => {
  button.addEventListener("click", function (event) {
    submenuHandleEfdc(event, button);
  });
});

//function to handle submenu actions
function submenuHandleEfdc(event, button) {
  var parentLi = button.closest(".menu-main__item");
  var link = parentLi.querySelector(".menu-main__link");
  var submenu = parentLi.querySelector(".menu-main__submenu");
  var isExpanded = button.getAttribute("aria-expanded") === "true";

  if (submenu) {
    const activeClass = "menu-main__submenu--active";
    button.setAttribute("aria-expanded", !isExpanded);
    parentLi.classList.toggle("menu-main__item--active");

    if (toggleHeightEfdc(submenu, activeClass)) {
      focusFirstElementEfdc(submenu);
    }

    submenu.addEventListener("focusout", function (event) {
      if (
        !submenu.contains(event.relatedTarget) &&
        !button.contains(event.relatedTarget) &&
        window.getComputedStyle(submenu).position === "absolute"
      ) {
        closeSubmenuEfdc(button, parentLi, submenu);
      }
    });

    document.addEventListener("click", function (event) {
      if (
        !submenu.contains(event.target) &&
        !button.contains(event.target) &&
        window.getComputedStyle(submenu).position === "absolute"
      ) {
        closeSubmenuEfdc(button, parentLi, submenu);
      }
    });

    link.addEventListener("focus", function (event) {
      if (window.getComputedStyle(submenu).position === "absolute") {
        closeSubmenuEfdc(button, parentLi, submenu);
      }
    });
  }
}

window.addEventListener("resize", function () {
  mobileMenuToggleEfdc(true);
});

//function to calculate available  max height for submenu
function checkHeightForSubmenuEfdc() {
  const navWrap = document.getElementById("menu-main-nav");
  const submenu = document.querySelector(".menu-main__submenu--active");
  if (!navWrap || !submenu) {
    return;
  }
  let height;

  if (window.getComputedStyle(navWrap).position !== "absolute") {
    if (submenu) {
      height = submenu.scrollHeight;
      submenu.style.height = `${height}px`;
    }
  } else {
    const header = document.querySelector(".header__top");
    const headerHeight = header ? header.offsetHeight : 0;

    // Calculate the total height of the menu
    const menuItems = document.querySelectorAll(
      "#menu-efdc-main-menu > .menu-main__item > .menu-main__link"
    );
    let menuItemsHeight = 0;
    menuItems.forEach((item) => {
      menuItemsHeight += item.offsetHeight;
    });

    // Check if WordPress admin menu exists and get height
    const wpadminbar = document.querySelector("#wpadminbar");
    const wpadminbarHeight = wpadminbar ? wpadminbar.offsetHeight : 0;

    // Calculate the total height
    const totalHeight = headerHeight + menuItemsHeight + wpadminbarHeight;

    // Calculate the submenu height
    const windowHeight = window.innerHeight;
    height = windowHeight - totalHeight;

    if (submenu) {
      submenu.style.height = `${height}px`;
    }
  }
  return height;
}
//function to toggle mobile menu
function mobileMenuToggleEfdc(forceClose = false) {
  var nav = document.getElementById("menu-main-nav");
  var toggleButton = document.getElementById("main-menu-toggle");
  var isExpanded = toggleButton.getAttribute("aria-expanded") === "true";

  var button = document.querySelector(".menu-main__button");

  if (forceClose || isExpanded) {
    toggleButton.setAttribute("aria-expanded", false);
    toggleButton.classList.remove("menu-toggle--open");
    nav.classList.remove("header__menu--active");
    if (button) {
      var parentLi = button.closest(".menu-main__item");
      var submenu = parentLi.querySelector(".menu-main__submenu--active");
      closeSubmenuEfdc(button, parentLi, submenu);
    }
    document.body.classList.remove("body-disabled");
  } else {
    toggleButton.setAttribute("aria-expanded", true);
    toggleButton.classList.add("menu-toggle--open");
    nav.classList.add("header__menu--active");
    document.body.classList.add("body-disabled");
  }
}

//function to calculate height of the element for the slide animation
function toggleHeightEfdc(nav, activeClass) {
  if (!nav.classList.contains(activeClass)) {
    nav.classList.add(activeClass);
    nav.style.height = "0px";
    checkHeightForSubmenuEfdc();
    return true;
  } else {
    nav.style.height = "0px";

    nav.addEventListener(
      "transitionend",
      function () {
        nav.classList.remove(activeClass);
      },
      {
        once: true,
      }
    );
    return false;
  }
}

//function to focus the first element
function focusFirstElementEfdc(submenu) {
  const focusableElements = submenu.querySelectorAll(
    'a, button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])'
  );
  if (focusableElements.length > 0) {
    focusableElements[0].focus();
  }
}

// function to close submenu
function closeSubmenuEfdc(button, parentLi, submenu) {
  button.setAttribute("aria-expanded", false);
  parentLi.classList.remove("menu-main__item--active");
  submenu = document.querySelector(".menu-main__submenu--active");
  if (submenu) {
    submenu.classList.remove("menu-main__submenu--active");
  }
}
